// AGC: Hook exposing feature availability based on BUILD-TIME context
// AGC: CRITICAL - Uses import.meta.env.VITE_APP_CONTEXT (build flag), NOT runtime detection
// AGC: This ensures desktop builds always show desktop UI, Base App builds always show Base App UI
// AGC: Shared across all FarmProHub apps

import { useMemo } from 'react'
import { getAppContext, isDesktopApp, isBaseAppContext } from '../utils/farcaster-detection'

export interface FeatureFlags {
  isFarcasterContext: boolean // AGC: Deprecated, use isBaseAppContext instead
  isBaseAppContext: boolean
  isDesktopContext: boolean
  isAdminEnabled: boolean
}

export const useFeatureFlags = (): FeatureFlags => {
  return useMemo(() => {
    // AGC: CRITICAL - Use runtime detection (getAppContext) for proper context awareness
    // AGC: This allows Base App preview tools to work correctly even with desktop builds
    const context = getAppContext()

    // AGC: Allow admin panel on localhost (any port) for development, even in Base App builds
    // AGC: This enables admin access at http://localhost:3001/#admin without breaking production
    const isLocalhost = typeof window !== 'undefined' && 
      (window.location.hostname === 'localhost' || 
       window.location.hostname === '127.0.0.1' ||
       window.location.hostname.startsWith('192.168.'))

    return {
      // AGC: Legacy property for backward compatibility (deprecated)
      isFarcasterContext: context === 'baseapp',
      isBaseAppContext: context === 'baseapp',
      isDesktopContext: context === 'desktop',
      // AGC: Admin panel enabled on desktop OR localhost (for development access)
      // AGC: Production Base App builds will still block admin panel (not localhost)
      isAdminEnabled: context === 'desktop' || isLocalhost,
    }
  }, [])
}

